<template>
  <div id="popup-container">
    <v-toolbar dark color="primary">
      <v-toolbar-title class="heading-title">
        Import users from HR Platform
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab x-small class="close" @click="closePanel">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container>
      <v-row>
        <v-col class="pa-0">
          <v-btn v-if="loading" color="primary" loading></v-btn>
            <v-btn v-else
              class="btn mr-1 add-course-button"
              color="primary"
              @click.prevent="syncHrUsers"
              >Sync Users</v-btn>
        </v-col>
        </v-row>
        <v-row class="mt-5">
          <div class="syncNote">
              Currently sync will work with  {{ this.name }}<br/><br/>
              What happens when I click Sync Users……<br/><br/>
              1. Our platform will sync all the users from your compatible HR platform and add them as a ‘User’ inside Senso Learn (<i>provided that this action does not cause the user limit to be exceeded</i>).<br/><br/>
              2. Users will become “Archived users” in Senso Learn if the user(s) within your HR platform has been marked as left the business (<i>if the user is not already archived in Senso Learn</i>).<br /><br/>
              3. User(s) won't be added or updated immediately. It will take up to 5 mins for the HR platform to provide Senso Learn with the update.<br/><br/>
            <span v-if="this.name != 'Sage HR'">
              4. When a user/s completes a course Senso Learn will update the HR platform only if the user has passed the course.
            </span>

          </div>
        </v-row> 
    </v-container>
  </div>
</template>
<script>
import { EventBus } from '@/event-bus.js';
import userAPI from '@/api/user.js';
export default {
  name: 'HRPlatform',
  data() {
    return {
      loading: false,
      successMessage: 'The user sync process has been successfully started.',
      errorMessage: 'Oops, something went wrong! Please check information is correct.',
      confirmImport: 'Are you sure you wish to import users from the HR Platform?',
    };
  },
  props: {
    name: {
      type: String,
      default: null
    }
  },
  computed: {
  },
  mounted() {
  },
  methods: {
    closePanel() {
      this.$emit('closePanel', {});
    },
    syncHrUsers() {
      this.$snotify.confirm(this.confirmImport, {
        backdrop: 0.3,
        buttons: [
          { text: 'Cancel', className: 'toast-cancel-button' },
          {
            text: 'Continue',
            className: 'toast-continue-button',
            action: (toast) => this.importHrUsers(toast),
          },
        ],
      });
    },
    importHrUsers(toast) {
      this.$snotify.remove(toast.id);
      this.loading = true;
      let userId = this.$store.getters.user.id;
      let companyId = this.$store.getters.user.company.data.id;
      userAPI
        .importHrUsers(companyId,userId)
        .then(() => {
          EventBus.$emit('USERS_UPDATED');
          this.$snotify.success(this.successMessage);
          this.closePanel();
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch(() => {
          this.loading = false;
          this.$snotify.error(this.errorMessage);
          this.closePanel();
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
  },
};
</script>
